/* Statischer Einstieg und Theme-Editor-Lifecycle.

   Vorbereiten statt Starten: Sobald die Flaeche sichtbar wird oder jemand auf
   sie zugeht (Zeiger, Fokus, Beruehrung), laedt der Loader Ablauf-Styles und
   Bundle im Hintergrund und ruft nach dem Definieren `prepare()` am Element;
   das holt nur den Inhalt der aktiven Version. Die Vorbereitung zeigt nichts,
   sperrt nichts und meldet keinen Fehler. Die Ablauf-Styles treffen nur
   Klassen, die erst der Start setzt; der Einstieg bleibt, wie er ist.

   Gestartet wird erst mit der Speicherentscheidung und erst, wenn beide
   Dateien da sind. Was die Vorbereitung schon angefragt hat, fragt der Start
   nicht noch einmal an. */
(function () {
  'use strict';
  // Das Asset kann in mehreren Sections stehen; ein Dokument braucht nur einen Manager.
  const flag = 'data-custom-bt-quiz-loader-ready';
  if (document.documentElement.hasAttribute(flag)) return;
  document.documentElement.setAttribute(flag, '');
  const name = 'custom-bt-quiz';
  const instances = new Map();

  // Ablauf-Styles und Bundle haengen je Adresse hoechstens einmal im Dokument,
  // auch bei mehreren Flaechen. Jede Flaeche haelt, was sie angefragt hat. Eine
  // Datei verschwindet, sobald sie scheitert oder keine Flaeche sie mehr haelt;
  // die naechste Anfrage haengt sie dann neu ein.
  const files = new Map();

  function acquire(root, url, tag) {
    let file = files.get(url);
    if (!file) {
      const node = document.createElement(tag);
      const created = { node: node, ready: false, holders: new Set() };
      node.addEventListener('load', function () { created.ready = true; });
      node.addEventListener('error', function () { drop(url, created); });
      if (tag === 'link') {
        node.rel = 'stylesheet';
        node.href = url;
      } else {
        node.defer = true;
        node.src = url;
      }
      files.set(url, created);
      document.head.appendChild(node);
      file = created;
    }
    file.holders.add(root);
    return file;
  }

  function drop(url, file) {
    if (files.get(url) === file) files.delete(url);
    file.node.remove();
  }

  function release(root) {
    for (const [url, file] of files) {
      file.holders.delete(root);
      if (file.holders.size === 0) drop(url, file);
    }
  }

  function mount(root) {
    if (instances.has(root)) return;
    const events = new AbortController();
    const errorBox = root.querySelector('[data-quiz-loader-error]');
    const retry = root.querySelector('[data-quiz-retry]');
    const bundleUrl = root.getAttribute('data-bundle-url');
    const stylesUrl = root.getAttribute('data-run-css-url');
    let pending = null;
    let watching = null;

    function releaseAttempt() {
      if (!pending) return;
      window.clearTimeout(pending.timer);
      pending.events.abort();
      pending = null;
    }

    function current(attempt) {
      return pending === attempt && root.isConnected && !events.signal.aborted;
    }

    function fail(attempt) {
      if (!current(attempt)) return;
      releaseAttempt();
      release(root);
      root.setAttribute('aria-busy', 'false');
      if (errorBox) errorBox.hidden = false;
      const dialog = root.closest('dialog');
      if (retry && (!dialog || dialog.open)) retry.focus();
    }

    function done(attempt) {
      if (!current(attempt)) return;
      releaseAttempt();
      if (errorBox) errorBox.hidden = true;
      // Das Nachladen ist vorbei. Der Client meldet sein eigenes Laden selbst;
      // ohne diese Freigabe bliebe die Flaeche sonst dauerhaft beschaeftigt.
      root.setAttribute('aria-busy', 'false');
      if (typeof root.start === 'function') {
        root.start(root.getAttribute('data-history-permission'));
      }
    }

    // Die Styles sind da; es fehlt nur noch die Definition des Elements.
    function awaitBundle(attempt) {
      if (!current(attempt)) return;
      if (window.customElements.get(name)) {
        done(attempt);
        return;
      }
      // whenDefined ist nicht abbrechbar. Die Versuchspruefung verhindert einen
      // spaeten Start nach Timeout, Wiederholung oder Section-Unload.
      window.customElements.whenDefined(name).then(function () { done(attempt); });
    }

    function boot() {
      if (pending || !root.isConnected || events.signal.aborted) return;
      stopWatching();
      const attempt = { events: new AbortController(), timer: 0 };
      pending = attempt;
      if (errorBox) errorBox.hidden = true;
      root.setAttribute('aria-busy', 'true');
      if (!window.customElements || !bundleUrl) { fail(attempt); return; }
      attempt.timer = window.setTimeout(function () { fail(attempt); }, 15000);
      const signal = { signal: attempt.events.signal };
      // Beide Dateien laden parallel; gestartet wird erst, wenn beide da sind.
      if (!window.customElements.get(name)) {
        const bundle = acquire(root, bundleUrl, 'script');
        bundle.node.addEventListener('error', function () { fail(attempt); }, signal);
      }
      if (!stylesUrl) { awaitBundle(attempt); return; }
      const styles = acquire(root, stylesUrl, 'link');
      if (styles.ready) { awaitBundle(attempt); return; }
      styles.node.addEventListener('load', function () { awaitBundle(attempt); }, signal);
      styles.node.addEventListener('error', function () { fail(attempt); }, signal);
    }

    function prepare() {
      if (events.signal.aborted || !root.isConnected) return;
      if (typeof root.prepare === 'function') root.prepare();
    }

    // Einmal je Flaeche. Ein Fehler bleibt hier still; erst der Start meldet ihn.
    function warm() {
      if (!watching || events.signal.aborted || !root.isConnected) return;
      stopWatching();
      if (!window.customElements || !bundleUrl) return;
      if (stylesUrl) acquire(root, stylesUrl, 'link');
      if (window.customElements.get(name)) { prepare(); return; }
      // Nach dem Laden des Bundles ist das Element definiert.
      acquire(root, bundleUrl, 'script').node.addEventListener('load', function () {
        if (window.customElements.get(name)) prepare();
      }, { signal: events.signal });
    }

    function stopWatching() {
      if (!watching) return;
      watching.events.abort();
      if (watching.observer) watching.observer.disconnect();
      watching = null;
    }

    for (const button of root.querySelectorAll('[data-quiz-start]')) {
      button.addEventListener('click', function () {
        const choice = button.getAttribute('data-history-permission');
        if (choice !== 'granted' && choice !== 'declined') return;
        root.setAttribute('data-history-permission', choice);
        boot();
      }, { signal: events.signal });
    }
    if (retry) retry.addEventListener('click', boot, { signal: events.signal });

    instances.set(root, function () {
      events.abort();
      stopWatching();
      releaseAttempt();
      release(root);
      root.setAttribute('aria-busy', 'false');
      instances.delete(root);
    });

    if (root.getAttribute('data-mode') === 'result') {
      const key = 'custom-bt-quiz:v1:' + root.getAttribute('data-quiz-key') + ':' + root.getAttribute('data-locale');
      let stored = null;
      try { stored = window.sessionStorage.getItem(key); } catch (_) { /* Speicherung kann gesperrt sein. */ }
      if (stored) {
        root.setAttribute('data-history-permission', 'granted');
        boot();
      }
      return;
    }

    // Vorbereiten nur, wo es einen Startweg gibt: sobald die Flaeche sichtbar
    // wird (der Artikeldialog beim Oeffnen, die Section kurz vor dem
    // Erscheinen) oder bei einer Absicht in ihr.
    if (!root.querySelector('[data-quiz-start]')) return;
    watching = { events: new AbortController(), observer: null };
    const options = { signal: watching.events.signal, passive: true };
    for (const type of ['pointerenter', 'focusin', 'touchstart']) {
      root.addEventListener(type, warm, options);
    }
    if ('IntersectionObserver' in window) {
      watching.observer = new IntersectionObserver(function (entries) {
        for (const entry of entries) if (entry.isIntersecting) warm();
      }, { rootMargin: '200px 0px' });
      watching.observer.observe(root);
    }
  }

  function refresh() {
    for (const [root, cleanup] of instances) if (!root.isConnected) cleanup();
    for (const root of document.querySelectorAll('custom-bt-quiz')) mount(root);
  }

  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('shopify:section:unload', function (event) {
    for (const [root, cleanup] of instances) {
      if (event.detail && event.detail.sectionId === root.dataset.sectionId) cleanup();
    }
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh, { once: true });
  else refresh();
})();
